module.exports = __webpack_public_path__ + "static/Curtis Brockman-8c3d2f66dbbc3f4685b7d3c2ba5f72fb.png";